import { MessageCircle, Wind, Droplets, Lightbulb, ShieldCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { AMENITIES, waLink, WA_MESSAGES } from "./data";

const EXTRAS = [
  { icon: Droplets, label: "Cisterna de captación pluvial" },
  { icon: Lightbulb, label: "Iluminación LED integral" },
  { icon: ShieldCheck, label: "Sanitarios y accesorios de alta gama" },
  { icon: Wind, label: "Ventanales de aluminio negro" },
];

export default function Amenities() {
  return (
    <section id="amenidades" data-testid="amenities-section" className="relative py-24 sm:py-32 lg:py-40 bg-[#f4f2ea] overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          eyebrow="Amenidades"
          light
          title={<>El confort que necesitas,<br /><span className="text-[#bfa360] italic">cada día</span></>}
        />

        <div className="mt-14 lg:mt-20 grid sm:grid-cols-2 gap-5">
          {AMENITIES.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.07} y={26}>
              <article className="img-frame group relative rounded-2xl overflow-hidden border border-white/5 h-[340px] sm:h-[400px]">
                <img src={a.img} alt={a.title} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1c242f] via-[#1c242f]/35 to-transparent" />
                <div className="absolute bottom-0 p-7 sm:p-8">
                  <p className="mono text-[10px] uppercase tracking-[0.28em] text-[#bfa360] mb-2">
                    {String(i + 1).padStart(2, "0")}
                  </p>
                  <h3 className="font-display text-2xl sm:text-3xl text-[#f4f2ea] mb-2">{a.title}</h3>
                  <p className="text-sm text-[#ccd1c0] leading-relaxed max-w-sm">{a.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {EXTRAS.map((e, i) => (
            <Reveal key={e.label} delay={i * 0.06} y={18}>
              <div className="rounded-xl border border-[#1c242f]/10 bg-white p-6 h-full flex flex-col gap-4 hover:border-[#bfa360]/60 shadow-sm transition-colors duration-500">
                <e.icon size={22} className="text-[#bfa360]" />
                <p className="text-sm text-[#44503f] leading-snug">{e.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-14 text-center">
          <a
            data-testid="amenities-whatsapp-cta"
            href={waLink(WA_MESSAGES.general)}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 rounded-full border border-[#bfa360]/50 px-8 py-4 text-sm font-medium text-[#93803f] hover:bg-[#bfa360] hover:text-[#1c242f] transition-colors"
          >
            <MessageCircle size={16} />
            Quiero conocer las amenidades en persona
          </a>
        </Reveal>
      </div>
    </section>
  );
}
